import BillingsOrderRelatedTaxiDriverRequest from "../../../../../api/raily/billings/order/related/taxi-driver/billings-order-related-taxi-driver.request";
import BillingsOrderRelatedTaxiDriverParams from "./billings-order-related-taxi-driver-params";

const create = (
  params: BillingsOrderRelatedTaxiDriverParams,
): BillingsOrderRelatedTaxiDriverRequest => {
  return {
    orderId: params.orderUuid,
  };
};

const billingsOrderRelatedTaxiDriverParamsFactory = {
  create,
};

export default billingsOrderRelatedTaxiDriverParamsFactory;
